import { z } from "zod";

export const NieuwsInhoud = z.object({
  intro: z.string(),
  kernpunten: z.array(z.string()),
  secties: z.array(z.object({ kop: z.string(), alineas: z.array(z.string()), link_pad: z.string().nullable(), link_tekst: z.string().nullable() })),
  vragen: z.array(z.object({ vraag: z.string(), antwoord: z.string() })),
});
export const NieuwsConcept = z.object({
  slug: z.string(), titel: z.string(), beschrijving: z.string(), zoekwoord: z.string(), dienst_slug: z.string(),
  inhoud: NieuwsInhoud,
});
export type NieuwsTekst = z.infer<typeof NieuwsInhoud>;
export const nieuwsTekst = (tekst: string) => tekst.replace(/\s*\(\[[^\]]+\]\(https?:\/\/[^\s)]+\)\)/g, "").replace(/\[([^\]]+)\]\(https?:\/\/[^\s)]+\)/g, "$1");
export type NieuwsArtikel = z.infer<typeof NieuwsConcept> & { id: string; gepubliceerd_op: string; gewijzigd_op: string; bronnen: { url: string; titel: string }[] };
export const publicatiedag = (datum = new Date()) => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Amsterdam", year: "numeric", month: "2-digit", day: "2-digit" }).format(datum);
export const nieuwsDatum = (datum: string) => new Date(datum).toLocaleDateString("nl-NL", { timeZone: "Europe/Amsterdam", day: "numeric", month: "long", year: "numeric" });

export const nieuwsDatumPill = (datum: string) =>
  new Date(datum)
    .toLocaleDateString("nl-NL", { timeZone: "Europe/Amsterdam", day: "numeric", month: "short", year: "numeric" })
    .replace(/\./g, "")
    .toUpperCase();

export function controleerNieuws(concept: z.infer<typeof NieuwsConcept>, toegestanePaden: string[]) {
  if (!/^[a-z0-9]+(-[a-z0-9]+)*$/.test(concept.slug)) throw new Error("Ongeldige artikellink.");
  if (concept.titel.length < 20 || concept.titel.length > 100 || concept.beschrijving.length < 80 || concept.beschrijving.length > 170) throw new Error("Paginagegevens voldoen niet aan de inhoudscontrole.");
  const tekst = [concept.inhoud.intro, ...concept.inhoud.secties.flatMap(s => [s.kop, ...s.alineas]), ...concept.inhoud.vragen.flatMap(v => [v.vraag, v.antwoord])].join(" ");
  if (tekst.split(/\s+/).length < 450 || concept.inhoud.secties.length < 4 || concept.inhoud.kernpunten.length < 3) throw new Error("Artikel bevat onvoldoende inhoud.");
  if (/<[^>]+>/.test(tekst)) throw new Error("HTML is niet toegestaan in artikeltekst.");
  const links = concept.inhoud.secties.filter(s => s.link_pad);
  if (links.length < 2 || links.some(s => !s.link_pad || !toegestanePaden.includes(s.link_pad) || !s.link_tekst)) throw new Error("Interne verwijzingen voldoen niet aan de controle.");
  return concept;
}